






































import Vue from "vue";
import EmailChip from "./EmailChip.vue";
import { isEmail } from "@/utils/validate";
import { uniq, emptyFn } from "@/fp";
import {
  Ref,
  ref,
  watch,
  onMounted,
  computed,
  onBeforeUnmount,
} from "@vue/composition-api";
import { onElEvent } from "@/common/dom.functions";

export default Vue.extend({
  components: {
    EmailChip,
  },
  props: {
    onEmails: {
      type: Function,
      required: true,
    },
    error: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit, root: { $nextTick } }) {
    const isFocused = ref(true);
    const emails: Ref<Array<{ val: string; isValid: boolean }>> = ref([]);
    const cEmail = ref("");
    const error = ref("");

    const emailInput = (): HTMLInputElement =>
      document.querySelector("#emailInput") as HTMLInputElement;

    const placeholder = computed(() => {
      return emails.value.length == 0 ? "Type email address" : "";
    });

    const showErrorMsg = computed(
      () => error.value.length > 0 && emails.value.some((d) => !d.isValid)
    );

    const isValidEmail = (email: string) => {
      const isValidPattern = isEmail(email);
      return isValidPattern;
    };

    /**
     * @description
     * waiting for the addition of "," | " " to finish
     * and then we set the value to "".
     */
    const clearInput = () => {
      setTimeout(() => {
        cEmail.value = "";
      }, 0);
    };

    const onPaste = () => {
      setTimeout(() => {
        const emailList = uniq(cEmail.value.replace(/ +?/g, "").split(",")).map(
          (email) => {
            return {
              val: email,
              isValid: isValidEmail(email),
            };
          }
        );
        emails.value = uniq([...emails.value, ...emailList]);
        clearInput();
      }, 0);
    };

    const addOrRejectEmail = () => {
      if (cEmail.value.length > 0) {
        emails.value = uniq([
          ...emails.value,
          { val: cEmail.value, isValid: isValidEmail(cEmail.value) },
        ]);
      }
      clearInput();
    };

    const onKeyPress = async (keyEvent: KeyboardEvent) => {
      if (
        emails.value.length > 0 &&
        keyEvent.keyCode === 13 &&
        cEmail.value.length === 0
      ) {
        // user wants to send the emails!
        emit("send");
      }
      // keys [',' , 'enter' , 'space']
      if ([44, 13, 32].includes(keyEvent.keyCode)) {
        addOrRejectEmail();
      }
    };
    /**
     * @description Triggers when the user @keydown the "Delete" | "Backspace"
     * buttons.
     * we remove the last email on the emails list.
     */
    const onDeletePress = async () => {
      if (emails.value.length === 0) {
        await $nextTick();
        if (isValidEmail(cEmail.value)) {
          // @ts-ignore
          props.onEmails([cEmail.value]);
        } else {
          // @ts-ignore
          props.onEmails([]);
        }
      } else if (emails.value.length > 0 && cEmail.value.trim().length == 0) {
        emails.value = emails.value.slice(0, emails.value.length - 1);
      }
    };

    const removeEmail = (email: string) => {
      emails.value = emails.value.filter((e) => e.val != email);
    };

    const focus = () => emailInput().focus();

    watch(emails, (_emails) => {
      // @ts-ignore
      props.onEmails(_emails.filter((e) => e.isValid).map((e) => e.val));
    });

    const onFocus = onElEvent("focus")(() => emailInput());
    const onBlur = onElEvent("blur")(() => emailInput());
    const subs = {
      focus: emptyFn(),
      blur: emptyFn(),
    };

    onMounted(() => {
      focus();
      subs.focus = onFocus(() => (isFocused.value = true));
      subs.blur = onBlur(() => (isFocused.value = false));
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
    });

    return {
      isFocused,
      emails,
      cEmail,
      placeholder,
      showErrorMsg,
      onPaste,
      onKeyPress,
      onDeletePress,
      removeEmail,
      focus,
    };
  },
});
